import { render } from "./Post.vue?vue&type=template&id=5a1a0ce2&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=5a1a0ce2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1a0ce2"]])

export default __exports__